export const DEFAULT_AVATAR =
  'https://apostbucket.s3.ap-northeast-2.amazonaws.com/images/default_user_photo.png'

export enum WALLET_ID {
  OneKey = 'OneKey',
  Phantom = 'a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393',
  OKX = 'OKX Wallet',
  Solflare = '1ca0bdd4747578705b1939af023d120677c64fe6ca76add81fda36e350605e79',
  Metamask = 'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
  Trust = '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
  Bitget = '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662',
  TokenPocket = 'TokenPocket'
}

export const WALLET_SOLANA = {
  [WALLET_ID.OKX]: window.okxwallet?.solana,
  [WALLET_ID.Phantom]: window.phantom?.solana,
  [WALLET_ID.Solflare]: window.solflare,
  [WALLET_ID.OneKey]: window.$onekey?.solana,
  [WALLET_ID.Trust]: window.trustwallet?.solana
  // [WALLET_ID.Bitget]: window.bitkeep?.solana,
  // [WALLET_ID.TokenPocket]: window.solana
}

export enum CONNECTION_STATUS {
  Connected = 'connected',
  Disconnected = 'disconnected'
}
